import { EntityType } from '../../../../shared/components/EntityType/EntityType';
import { PipelineSyncFrequencyDisplay } from '../../../PipelineSyncFrequency/PipelineSyncFrequencyDisplay';
import { GenericStatusLabel } from '../../../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { TableColumn } from '../../../../table/interfaces/table';
import { Integration } from '../../../../shared/interfaces/integration';
// import { PipelineActionsFactory } from '../../../PipelineActions/factory/pipelineActionsFactory';
// import { EntityKebabMenuActionButton } from '../../../../entity-kebab-menu-actions/components/EntityKebabMenuActionButton';

export const pipelineListColumns = () // onActionClick: (pipeline: Integration) => void
: TableColumn<Integration>[] => {
  return [
    {
      id: 'c1',
      field: 'id',
      headerName: 'ID',
      width: 40,
      valueFormatter: params => `#${params.row.data.seqId}`
    },
    {
      id: 'c2',
      field: 'name',
      headerName: 'Pipeline Name',
      wrapOverflowingCellText: true,
      width: 200,
      isFlexible: true
    },
    {
      id: 'c3',
      field: 'source',
      headerName: 'Source',
      width: 200,
      isFlexible: true,
      renderCell: params => {
        const { source } = params.row.data;

        if (!source) {
          return (
            <span className='text-normal text-secondary' data-id='no-source-configured'>
              Not configured yet
            </span>
          );
        }

        return (
          <EntityType
            logo={source.sourceType.logo}
            logoDarkMode={source.sourceType.logo}
            title={source.name}
          />
        );
      }
    },
    {
      id: 'c4',
      field: 'destination',
      headerName: 'Destination',
      width: 200,
      isFlexible: true,
      renderCell: params => {
        const { destination } = params.row.data;

        if (!destination) {
          return (
            <span className='text-normal text-secondary' data-id='no-destination-configured'>
              Not configured yet
            </span>
          );
        }

        return (
          <EntityType
            logo={destination.destinationType.logo}
            logoDarkMode={destination.destinationType.logo}
            title={destination.name}
          />
        );
      }
    },
    {
      id: 'c5',
      field: 'config.sync_frequency_schedule',
      headerName: 'Sync Frequency',
      wrapOverflowingCellText: true,
      width: 160,
      renderCell: params => <PipelineSyncFrequencyDisplay pipeline={params.row.data} />
    },
    {
      id: 'c6',
      field: 'createdBy',
      headerName: 'Created by',
      width: 100,
      wrapOverflowingCellText: true,
      isFlexible: true
    },
    {
      id: 'c7',
      field: 'status',
      headerName: 'Status',
      wrapOverflowingCellText: true,
      isFlexible: true,
      width: 100,
      renderCell: params => (
        <GenericStatusLabel
          status={params.row.data.status}
          withIcon={!!params.row.data.status.icon}
        />
      )
    }

    // {
    //   id: 'c7',
    //   field: 'actions',
    //   headerName: null,
    //   isFlexible: true,
    //   headerCellAlign: 'flex-end',
    //   cellAlign: 'flex-end',
    //   wrapOverflowingCellText: true,
    //   width: 100,
    //   renderCell: params => {
    //     const actions = PipelineActionsFactory(params.row.data);

    //     if (actions.length === 0) {
    //       return null;
    //     }

    //     return (
    //       <EntityKebabMenuActionButton
    //         label='Pipeline Actions'
    //         target={`pipeline-${params.row.data.id}-actions`}
    //         className='mr-2'
    //         onClick={() => onActionClick(params.row.data)}
    //       />
    //     );
    //   }
    // }
  ];
};
